import {
  CustomBodyCell,
  CustomHeaderCell,
  CustomTable,
  CustomTableContainer,
  CustomTableRow,
} from '@components/Styles/TableStyle';
import { useNavigate } from 'react-router-dom';
import { Checkbox, Button, TableBody, TableHead, Select, MenuItem } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { CustomSorting } from '@components/Styles/TableStyle';
import Pagination from '@components/common/Shared/Pagination';
import { CustomButton } from '@components/Styles/ButtonStyle';
import CustomInput from '@components/common/Input/CustomInput';
import { CustomStack } from '@components/Styles/CommonStyle';
import React from 'react';
import { SectionWrapper } from '@components/Styles/CommonStyle';
import { Typography } from '@mui/material';
import { theme } from '@components/Styles/theme';
import { businessNoFormatter, formatPhoneNumber } from '@utils/formatter';

const CompanyAccountListTable = ({
  companyAccountList,
  companyAccountListTotal,
  setName,
  onSearch,
  onDefaultSearch,
  page,
  pageSize,
  onDeleteAccount,
  checkedAccountList,
  handleCheckboxChange,
  handleCheckAll,
  isCheckboxAllSelect,
  setPage,
  setPageSize,
  orderBy,
  setOrderBy,
  orderDir,
  setOrderDir,
}) => {
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <SectionWrapper>
        <CustomStack mb={2}>
          <Typography sx={theme.typography.h4}>검색</Typography>
        </CustomStack>
        <CustomTableContainer>
          <CustomTable>
            <TableBody>
              <CustomTableRow>
                <CustomHeaderCell>업체명</CustomHeaderCell>
                <CustomBodyCell>
                  <CustomInput
                    onChange={(e) => setName(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        onSearch();
                      }
                    }}
                  />
                </CustomBodyCell>
              </CustomTableRow>
            </TableBody>
          </CustomTable>
        </CustomTableContainer>
        <CustomStack justifyContent="center" mt={2}>
          <CustomButton type="search" onClick={onSearch}>
            검색
          </CustomButton>
        </CustomStack>
      </SectionWrapper>

      <SectionWrapper>
        <CustomStack justifyContent="spaceBetween" mb={2}>
          <Typography sx={theme.typography.h4}>법인 사업자 리스트</Typography>
          <CustomStack justifyContent="spaceBetween" mb={2}>
            <CustomButton onClick={() => navigate('/account/companyAccountCreate')}>신규등록</CustomButton>
          <CustomButton color="error" onClick={() => {onDeleteAccount();}}>삭제</CustomButton>
          </CustomStack>
        </CustomStack>
        <CustomTableContainer>
          <CustomTable>
            <TableHead>
              <CustomTableRow>
                <CustomHeaderCell align="center">
                  <Checkbox                  
                    checked={isCheckboxAllSelect}    
                    onChange={handleCheckAll}
                    />
                </CustomHeaderCell>
                <CustomHeaderCell align="center">NO</CustomHeaderCell>
                <CustomHeaderCell align="center">
                  업체명
                  {
                    orderBy === 'company_name' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('company_name');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting> :
                    orderBy === 'company_name' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('company_name');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting> :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('company_name');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  사업자 번호
                  {
                    orderBy === 'business_no' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('business_no');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting> :
                    orderBy === 'business_no' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('business_no');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting> :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('business_no');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  대표자
                  {
                    orderBy === 'ceo_name' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('ceo_name');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting> :
                    orderBy === 'ceo_name' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('ceo_name');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting> :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('ceo_name');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  주소
                  {
                    orderBy === 'address1' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('address1');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting> :
                    orderBy === 'address1' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('address1');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting> :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('address1');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  사업자 등록증
                  {
                    orderBy === 'business_cert_url' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('business_cert_url');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting> :
                    orderBy === 'business_cert_url' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('business_cert_url');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting> :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('business_cert_url');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  통장 사본
                  {
                    orderBy === 'bankbook_url' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('bankbook_url');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting> :
                    orderBy === 'bankbook_url' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('bankbook_url');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting> :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('bankbook_url');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  회사 전화
                  {
                    orderBy === 'company_tel' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('company_tel');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting> :
                    orderBy === 'company_tel' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('company_tel');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting> :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('company_tel');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  계산서 이메일
                  {
                    orderBy === 'invoice_email' && orderDir === 'ASC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('invoice_email');
                        setOrderDir('DESC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting> :
                    orderBy === 'invoice_email' && orderDir === 'DESC' ?
                    <CustomSorting
                      sorted
                      onClick={() => {
                        setOrderBy('invoice_email');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting> :
                    <CustomSorting
                      onClick={() => {
                        setOrderBy('invoice_email');
                        setOrderDir('ASC');
                      }}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  }
                </CustomHeaderCell>
              </CustomTableRow>
            </TableHead>
            <TableBody>
              {companyAccountList.length > 0 ? (
                companyAccountList.map((companyAccount, index) => {
                  return (
                    <CustomTableRow>
                      <CustomBodyCell align="center">
                        <Checkbox
                          checked={checkedAccountList.includes(companyAccount.id)}
                          onChange={(e) => handleCheckboxChange(e, companyAccount.id )}
                        />
                      </CustomBodyCell>
                      <CustomBodyCell align="center">
                        {companyAccountListTotal - ((page - 1) * pageSize + index)}
                      </CustomBodyCell>
                      <CustomBodyCell align="center">
                        <Button variant="text" 
                            onClick={() => navigate('/account/companyAccountCreate?id='+companyAccount.id )}>{companyAccount.company_name}
                        </Button>
                      </CustomBodyCell>
                      <CustomBodyCell align="center">{companyAccount.business_no ? businessNoFormatter(companyAccount.business_no) : '-'}</CustomBodyCell>
                      <CustomBodyCell align="center">{companyAccount.ceo_name ? companyAccount.ceo_name : '-'}</CustomBodyCell>
                      <CustomBodyCell>
                        {companyAccount.address1} {companyAccount.address2}
                      </CustomBodyCell>
                      {
                        companyAccount.business_cert_url !== null ?
                        <CustomBodyCell align="center">
                          <Button
                            variant="text"
                            onClick={(e) => {
                              e.stopPropagation();
                              window.open(process.env.REACT_APP_API_URL + companyAccount.business_cert_url, '_blank');
                            }}
                          >
                            파일보기
                          </Button>
                        </CustomBodyCell> :
                        <CustomBodyCell align="center">
                          -
                        </CustomBodyCell>
                      }
                      {
                        companyAccount.bankbook_url !== null ?
                        <CustomBodyCell align="center">
                          <Button
                            variant="text"
                            onClick={(e) => {
                              e.stopPropagation();
                              window.open(process.env.REACT_APP_API_URL + companyAccount.bankbook_url, '_blank');
                            }}
                          >
                            파일보기
                          </Button>
                        </CustomBodyCell> :
                        <CustomBodyCell align="center">
                          -
                        </CustomBodyCell>
                      }
                      <CustomBodyCell align="center">{companyAccount.company_tel ? formatPhoneNumber(companyAccount.company_tel) : '-'}</CustomBodyCell>
                      <CustomBodyCell align="center">{companyAccount.invoice_email ? companyAccount.invoice_email : '-'}</CustomBodyCell>
                    </CustomTableRow>
                  );
                })
              ) : (
                <CustomTableRow>
                  <CustomBodyCell colSpan={8} align="center">
                    등록된 법인 사업자가 없습니다.
                  </CustomBodyCell>
                </CustomTableRow>
              )}
            </TableBody>
          </CustomTable>

          <Select
            sx={{ mt: 2, width: '100px', height: '40px' }}
            value={pageSize}
            onChange={(e) => setPageSize(e.target.value)}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={30}>30</MenuItem>
          </Select>

          <Pagination count={Math.ceil(companyAccountListTotal / pageSize)} page={page} onChange={onDefaultSearch} />
        </CustomTableContainer>
      </SectionWrapper>
    </React.Fragment>
  );
};

export default CompanyAccountListTable;
